import type { Restaurant } from '@shared/types/restaurant';
import type { BookingContextValue } from '../state/types';
import { calculateGuaranteeFee, type FeeBreakdown } from './calculateFee';
import { activeSlotMenuFor } from './activeSlotMenu';
import { defaultTipPercent } from './gratuity';

/** The guarantee fee the payment step charges for the selected slot; null when no slot is selected. */
export function computeSlotFee(booking: BookingContextValue, restaurant: Restaurant): FeeBreakdown | null {
  const slot = booking.selectedTime && booking.timeSlots
    ? booking.timeSlots.find((s) => s.hour === booking.selectedTime)
    : null;
  if (!slot) return null;

  const hasMatchingSpecialRequest = !!(
    booking.allergies?.trim() ||
    booking.veggie ||
    booking.kids ||
    booking.pets
  );
  return calculateGuaranteeFee({
    slot,
    menu: activeSlotMenuFor(booking, restaurant.publicSearchMode),
    partySize: booking.diners,
    kidsCount: booking.kids ? booking.howManyKids : 0,
    settleUsd: !!restaurant.settleUsd,
    salesTaxPercent: restaurant.processingSalesTax ?? 0,
    checkoutProcessingFeePercent: restaurant.checkoutProcessingFeePercent,
    tipChargePercent: booking.tipChargePercent ?? defaultTipPercent(restaurant.specificServiceChargeOptions) ?? undefined,
    restaurant,
    isForeign: booking.isForeign,
    hasGiftCard: !!booking.giftCardToken,
    hasMatchingSpecialRequest,
    rescheduleOriginalType: booking.rescheduleOriginalType,
    selectedPairings: booking.selectedPairings,
    isAgent: booking.isAgentReservation,
    guaranteeCurrency: restaurant.reservationGuaranteeCurrency,
    restaurantCurrency: restaurant.currency,
  });
}
